import type {
  MemberPromotionFilters,
  MemberPromotionsTableColumns
} from '@library/types/members/memberPromotions';
import type { ComboboxOption } from '@library/components/selects';
import type { TableColumn } from '@library/types/utils';

export const PROMOTION_TYPE_OPTIONS: Array<ComboboxOption> = [
  {
    label: 'Cash Back',
    value: 'CashBack'
  },
  {
    label: 'Deposit Match',
    value: 'DepositMatch'
  },
  {
    label: 'Flash Sale',
    value: 'FlashSale'
  },
  {
    label: 'Free Entry Promotion',
    value: 'FreeEntryPromotion'
  },
  {
    label: 'Mission',
    value: 'Mission'
  },
  {
    label: 'Offer Card',
    value: 'OfferCard'
  },
  {
    label: 'Payout Boost',
    value: 'PayoutBoost'
  },
  {
    label: 'Protected Play',
    value: 'ProtectedPlay'
  },
  {
    label: 'Streaks Reward Promotion',
    value: 'StreaksRewardPromotion'
  }
];

export const defaultPromotionFilters: MemberPromotionFilters = {
  promotionType: undefined
};

export const MEMBER_PROMOTIONS_TABLE_HEADER: Array<
  TableColumn<MemberPromotionsTableColumns>
> = [
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: false,
    width: 'w-[5%] px-3'
  },
  {
    column: 'type',
    essential: true,
    label: 'Promotion type',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: false,
    width: 'w-1/5 px-3'
  },
  {
    column: 'fund_type',
    essential: true,
    label: 'Fund Type',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  },
  {
    column: 'start_date',
    essential: true,
    label: 'Start Date',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'end_date',
    essential: true,
    label: 'End Date',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'opted_in_at',
    essential: true,
    label: 'Opted In At',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'redeemed_at',
    essential: true,
    label: 'Redeemed At',
    sortEnabled: false,
    width: 'w-[10%] px-3'
  }
];
